export default __webpack_public_path__ + "static/media/Typhoon.5700da88.png";